// extracted by mini-css-extract-plugin
export default {"clickableBean":"StandaloneBean_clickableBean__QfaUr"};